"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnsitePromotionLocalizedReferenceSchema = void 0;
exports.OnsitePromotionLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/onsite-promotions.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "OnsitePromotionLocalizedReference",
    "description": "Used to promote the product, events and consumer activations.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:onsite-promotions"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib25zaXRlLXByb21vdGlvbnMuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvcmVmZXJlbmNlL2xvY2FsaXplZC9jb250ZW50L29uc2l0ZS1wcm9tb3Rpb25zLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLHVDQUF1QyxHQUFHO0lBQ3JELEtBQUssRUFBRSwyRkFBMkY7SUFDbEcsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsbUNBQW1DO0lBQzVDLGFBQWEsRUFBRSwrREFBK0Q7SUFDOUUsTUFBTSxFQUFFLFFBQVE7SUFDaEIsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLElBQUk7S0FDTDtJQUNELFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRTtnQkFDTiwrQkFBK0I7YUFDaEM7WUFDRCxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSxpR0FBaUc7U0FDN0c7S0FDRjtDQUNGLENBQUEifQ==